// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-archive-js": () => import("./../src/pages/archive.js" /* webpackChunkName: "component---src-pages-archive-js" */),
  "component---src-pages-contact-js": () => import("./../src/pages/contact.js" /* webpackChunkName: "component---src-pages-contact-js" */),
  "component---src-pages-index-js": () => import("./../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-retail-js": () => import("./../src/pages/retail.js" /* webpackChunkName: "component---src-pages-retail-js" */)
}

